import { PageController } from '@client/components/_core/layout/PageController';
import { PdsEdit } from '@client/components/pds/PdsEdit';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/configuration/claims-products/product-types/$productTypeId/add')({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'New PDS',
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageController route={Route}>
            <PdsEdit action={['add']} />
        </PageController>
    );
}
